import { i18n } from "@lingui/core";
import React from 'react';
import styled, { css } from 'styled-components';
import $switchCaseDefault from 'dolla-switch';
import * as Bento from '@prezi/bento';
import * as CommonDesign from '@prezi/common-design';
import { createDataLookup } from '../../const';
import { Dumb as Atoms } from '../../atoms';
import { DisabledComponentWithTooltipWrapper } from './';
import { localI18n } from '../../../i18n';
import SectionTitle from './SectionTitle';
const getNoLinksCopy = isShareLinkImprovementsActive => isShareLinkImprovementsActive ? localI18n._("Trackable links let you see exactly who views your presentation and access Prezi Analytics. You can deactivate these links at any time.") : localI18n._("This presentation does not have any trackable links");
const uxCopy = {
  title: localI18n._("Trackable links"),
  getDesc: (linkCount, isShareLinkImprovementsActive) => linkCount === 0 ? getNoLinksCopy(isShareLinkImprovementsActive) : i18n._("{linkCount, plural, one {This presentation has # trackable link} other {This presentation has # trackable links}}", {
    linkCount: linkCount
  }),
  createButton: localI18n._("Create link"),
  manageButton: localI18n._("Manage links"),
  tooltip: {
    title: localI18n._("Not allowed to create trackable links"),
    body: localI18n._("Creating trackable links is not allowed for documents in \"Only individuals can access\"")
  }
};
const getTooltipUxCopy = reason => $switchCaseDefault(reason, {
  notAllowedClosedPrivacy: () => ({
    title: i18n._("Not allowed to create trackable links"),
    body: i18n._("Creating trackable links is not allowed for documents in \"Only individuals can access\"")
  }),
  notAllowedInOrg: () => ({
    title: i18n._("Not allowed to create trackable links"),
    body: i18n._("Creating trackable links is disabled for your team")
  }),
  notAllowedShared: () => ({
    title: i18n._("Not allowed to manage trackable links"),
    body: i18n._("You do not have sufficient permission to manage trackable links")
  })
}, () => {
  throw `Invalid component state: ${reason}`;
});
const ContentGrid = styled.div.withConfig({
  displayName: "TrackableLinksOverview__ContentGrid",
  componentId: "sc-1mgxc6b-0"
})(["display:grid;grid-template-columns:auto min-content;align-items:center;", ""], p => p.hasGap && css(["column-gap:28px;margin-right:8px;"]));
const ContentBody = styled(Bento.Body2).withConfig({
  displayName: "TrackableLinksOverview__ContentBody",
  componentId: "sc-1mgxc6b-1"
})(["", " ", ""], p => p.disabled && css(["opacity:50%;"]), p => p.isSmallText && css(["font-size:12px;font-weight:600;"]));
const Wrapper = styled.div.withConfig({
  displayName: "TrackableLinksOverview__Wrapper",
  componentId: "sc-1mgxc6b-2"
})(["", ""], props => props.hasPadding ? 'padding-top: 16px' : '');
const CreateOrManageButton = ({
  createOrManage,
  isCrownIcon,
  disabled,
  onClick
}) => {
  return React.createElement(Atoms.TertiaryButton, {
    onClick: onClick,
    variant: "transparent",
    disabled: disabled,
    "data-lookup": createDataLookup('create-or-manage-links-button')
  }, createOrManage === 'create' ? React.createElement(React.Fragment, null, isCrownIcon ? React.createElement(CommonDesign.IconSmallCrown, null) : React.createElement(CommonDesign.IconSmallPlusLegacy, null), React.createElement("span", null, uxCopy.createButton)) : React.createElement(React.Fragment, null, React.createElement(CommonDesign.IconSmallSettingsLegacy, null), React.createElement("span", null, uxCopy.manageButton)));
};
const TrackableLinksOverview = ({
  onClick,
  linkCount,
  createControlContext,
  manageControlContext,
  hasShareLinkAccess,
  isShareLinkImprovementsActive
}) => {
  const createOrManage = linkCount > 0 ? 'manage' : 'create';
  const isDisabled = createOrManage === 'create' && createControlContext.disabled || createOrManage === 'manage' && manageControlContext.disabled;
  const disabledReason = createControlContext.reason || manageControlContext.reason;
  return React.createElement(Wrapper, {
    hasPadding: !isShareLinkImprovementsActive
  }, isShareLinkImprovementsActive ? React.createElement(SectionTitle, null, uxCopy.title) : React.createElement(Bento.Caption, null, uxCopy.title), React.createElement(ContentGrid, {
    hasGap: isShareLinkImprovementsActive
  }, React.createElement(ContentBody, {
    disabled: isDisabled,
    isSmallText: isShareLinkImprovementsActive
  }, uxCopy.getDesc(linkCount, isShareLinkImprovementsActive)), isDisabled ? React.createElement(DisabledComponentWithTooltipWrapper, {
    uxCopyTooltip: getTooltipUxCopy(disabledReason),
    paywall: createControlContext.paywall
  }, React.createElement(CreateOrManageButton, {
    disabled: isDisabled,
    createOrManage: createOrManage,
    isCrownIcon: !hasShareLinkAccess && isShareLinkImprovementsActive
  })) : React.createElement(CreateOrManageButton, {
    onClick: onClick,
    disabled: isDisabled,
    createOrManage: createOrManage,
    isCrownIcon: !hasShareLinkAccess && isShareLinkImprovementsActive
  })));
};
export default TrackableLinksOverview;